import { render, staticRenderFns } from "./view-orders.vue?vue&type=template&id=73924840&"
import script from "./view-orders.vue?vue&type=script&lang=js&"
export * from "./view-orders.vue?vue&type=script&lang=js&"
import style0 from "./view-orders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports